import axios from 'axios'
// import https from 'https'
import qs from 'qs'
import Url from './url'
// import router from '../router'
function containsVariables (str) {
  const pattern = /ChatBot|register|registerUserInfoExt|verifyAgreement/
  return pattern.test(str)
}
// 响应时拦截
axios.interceptors.response.use(function (response) {
  if (containsVariables(response.config.url) || [70003, 100014, 0].includes(Number(response.data.errorCode))) {
    return response.data
  } else if (Number(response.data.errorCode === 70006)) {
    return false
  } else if (Number(response.data.errorCode === 80000)) {
    // 失败1
    let data = response.data || {}
    window.vm.$msg(data.data && data.data.msg || '失败')
    return false
  } else {
    window.vm.$msg(response.data.msg)
    return false
  }
}, function (error) {
  // 当响应异常时做一些处理
  let err = error.response.status
  if (err === 400) {
    let errmsg = error.response.data.errorMsg
    window.vm.$msg(errmsg || '失败')
    // window.vm.$msg(err.data.errorMsg || '失败')
  } else {
    alert(error)
  }
  return Promise.reject(error.response)
})

export default {
  post (url, data) {
    console.log(data)
    var isUrl = Url.api
    return axios({
      method: 'post',
      baseURL: isUrl,
      url,
      // data: qs.stringify(data),
      data: data,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  postQs (url, data) {
    // var Data = this.prodata(data)
    var isUrl = Url.api
    return axios({
      method: 'post',
      baseURL: isUrl,
      url,
      data: qs.stringify(data),
      timeout: 10000,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  postJson (url, data) {
    var isUrl = Url.api
    return axios({
      method: 'post',
      baseURL: isUrl,
      url,
      data: data,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  // 新增post请求参数放在url中
  postJsonp (url, data) {
    var isUrl = Url.api
    return axios({
      method: 'post',
      baseURL: isUrl,
      url,
      params: data,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  postForm (url, data) {
    // var Data = this.prodata(data)
    var isUrl = Url.api
    return axios({
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      method: 'post',
      baseURL: isUrl,
      url,
      data: data,
      timeout: 10000
    })
  },
  // 接口批量更换   end
  get (url, params) {
    // var Data = this.prodata(params)
    return axios({
      method: 'get',
      baseURL: Url.api,
      url,
      params: params, // get 请求时带的参数
      timeout: 10000,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/config/http.js